import React from 'react';

import { Project } from '@qality/common-model';
import DialogUtils from '@qality/common-utils/src/DialogUtils';

import { DashboardActionsView } from './DashboardActions.view';

interface DashboardActionsProps {
  project: any;
  projectName: string;
  nameSuffix: string;
}

export const DashboardActions: React.FC<DashboardActionsProps> = ({
  project,
  projectName,
  nameSuffix,
}: DashboardActionsProps) => {
  const openPageInNewTab = async (pageUrl: string) => {
    await window.open(pageUrl, '_blank');
  };

  return (
    <DashboardActionsView
      projectName={projectName}
      nameSuffix={nameSuffix}
      openPageInNewTab={openPageInNewTab}
      openCreateTestCaseDialog={() => {
        DialogUtils.createTestCaseDialog(new Project(project));
      }}
    />
  );
};
